export const colors = {
    black: '#000000',
    darkGrey: '#0d0d0e',
    charcoalGrey: '#363839',
    slateGrey: '#5e6164',
    steel: '#878C90',
    silver: '#b7bbbf',
    paleGrey: '#e5e5ea',
    lightGrey: '#f1f5f6',
    alabaster: '#f8f9f9',
    white: '#ffffff',
    peacockBlue: '#0055b2',
    brightBlue: '#007bff',
    dodgerBlue: '#4da2ff',
    babyBlue: '#b3d7ff',
    reallyLightBlue: '#d2f0ff',
    iceBlue: '#e2f5fc',
    lipstick: '#cf1324',
    strawberry: '#ff273a',
    coral: '#fb5447',
    peach: '#ffd3d3',
    jungleGreen: '#058339',
    shamrockGreen: '#08bd52',
    evergreen: '#52d086',
    mint: '#b5ebcb',
    darkMustard: '#b38806',
    burntYellow: '#e0aa08',
    marigold: '#ffc107',
    lightTan: '#fbf2d7',
    transparent: 'rgba(255,255,255,0)',
};

export const statusColors = {
    OPEN: colors.coral,
    IN_PROGRESS: colors.shamrockGreen,
    ON_HOLD: colors.marigold,
    COMPLETE: colors.steel,

    border: {
        OPEN: colors.silver,
    },

    background: {
        COMPLETE: colors.alabaster,
    },
};

export const priorityColors = {
    NONE: colors.steel,
    LOW: colors.dodgerBlue,
    MEDIUM: colors.burntYellow,
    HIGH: colors.coral,
};

export default {
    colors,
    statusColors,
    priorityColors,
};
